import { render } from "./FarmerRegister.vue?vue&type=template&id=2e58fa20&scoped=true"
import script from "./FarmerRegister.vue?vue&type=script&lang=js"
export * from "./FarmerRegister.vue?vue&type=script&lang=js"

import "./FarmerRegister.vue?vue&type=style&index=0&id=2e58fa20&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-2e58fa20"

export default script